import React, { useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api } from "../utils/api";
import { API_ENDPOINTS } from "../constants/api";
import "./ResetPassword.css";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetEndpoint = useMemo(
    () => `${API_ENDPOINTS.AUTH.RESET_PASSWORD}/${token}`,
    [token]
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccessMessage("");

    if (password.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await api.post(resetEndpoint, { password });

      if (!response.ok) {
        const apiError = response?.data?.message || "Could not reset password.";
        setError(apiError);
        return;
      }

      setSuccessMessage(response.data?.message || "Password reset successful.");
      setTimeout(() => navigate("/"), 1500);
    } catch (requestError) {
      setError(requestError.message || "Network error while resetting password.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="reset-page">
      <div className="reset-card">
        <h1>Reset Password</h1>
        <p>Choose a new password for your account.</p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="password">New Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="At least 6 characters"
            disabled={isSubmitting}
            required
          />

          <label htmlFor="confirmPassword">Confirm Password</label>
          <input
            id="confirmPassword"
            type="password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            placeholder="Re-enter your password"
            disabled={isSubmitting}
            required
          />

          {error && <div className="reset-error">{error}</div>}
          {successMessage && <div className="reset-success">{successMessage}</div>}

          <button
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Resetting..." : "Reset password"}
          </button>
        </form>

        <Link
          to="/"
          className="reset-back-link"
        >
          Back to sign in
        </Link>
      </div>
    </div>
  );
};

export default ResetPassword;
